import classNames from "classnames";
import React from "react";
import "../../App.css";
import { IEvidenceCard } from "@interfaces/Interfaces";
import "./CommonComponents.css";

const EvidenceContentCard: React.FC<IEvidenceCard> = (props) => {
  return (
    <div
      className="reflectionContentCard bg-white"
      id={props.id}
    >
      <div
        className={classNames("reflectionContentCardTitle whitespace-pre-wrap", {
          "!mb-2": !!props.subtitle,
        })}
      >
        {props.title}
        <span className="text-cta-red">{props.mandatory && " (Mandatory)"}</span>
      </div>
      {props.subtitle && (
        <div className="reflectionContentCardTitle mb-1 mt-2 whitespace-pre-wrap !font-normal">{props.subtitle}</div>
      )}
      {props.children}
    </div>
  );
};

export default EvidenceContentCard;
